module.exports = __webpack_public_path__ + "0dfb5ef15abe6f327246d8ad943acd59.jpg";